import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { useTranslation } from '../../i18n/LanguageProvider';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

const historyImages = [
  {
    src: require('./../../assets/images/bookblock.jpg'),
    alt: 'Book block'
  },
  {
    src: require('./../../assets/images/calendar_on_the_table.jpg'),
    alt: 'Calendar on the table'
  },
  {
    src: require('./../../assets/images/landscape.jpg'),
    alt: 'Beautiful landscape'
  }
];

const AboutHistory = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  imageFill,
  invertMobile,
  invertDesktop,
  alignTop,
  ...props
}) => {
  const { t } = useTranslation();

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = t('aboutHistory.header');
  const items = t('aboutHistory.items');

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            {items.map((item, index) => {
              const revealDirection = index % 2 === 0 ? 'reveal-from-left' : 'reveal-from-right';
              const image = historyImages[index] || historyImages[0];

              return (
                <div className="split-item" key={item.title}>
                  <div className={`split-item-content center-content-mobile ${revealDirection}`} data-reveal-container=".split-item">
                    <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                      {item.eyebrow}
                    </div>
                    <h3 className="mt-0 mb-12">
                      {item.title}
                    </h3>
                    <p className="m-0">
                      {item.description}
                    </p>
                  </div>
                  <div
                    className={
                      classNames(
                        'split-item-image center-content-mobile reveal-from-bottom',
                        imageFill && 'split-item-image-fill'
                      )}
                    data-reveal-container=".split-item">
                    <Image
                      src={image.src}
                      alt={image.alt}
                      width={528}
                      height={396} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

AboutHistory.propTypes = propTypes;
AboutHistory.defaultProps = defaultProps;

export default AboutHistory;
